import _ from "lodash";
import { formatElapsed } from "../utils/format/format";
export class TrialsEntity {
    constructor(props) {
        this.props = props;
    }
    changeColorScore() {
        const formated = {
            ALTO: {
                class: "tag-cyan",
                label: "Alto"
            },
            MEDIO: {
                class: "tag-yellow",
                label: "Médio"
            },
            BAIXO: {
                class: "tag-pink",
                label: "Baixo"
            }
        };
        this.props.formatedScore = formated[this.props.score];
    }

    fomratedOrigin() {
        const origins = {
            CONTAZUL: "Conta Azul",
            CNCC: "CNCC",
            CNCC2: "CNCC 2",
            CNCC3: "CNCC 3",
            FREEMIUM: "Freemium",
            NTW: "NTW",
            "NUCONT XPERIENCE": "Nucont Xperience",
            "PROGRAMA VALOR": "Programa Valor",
            "cf-contabilidade": "CF-Contabilidade",
            "mentorados-robson-cavalcanti": "Mentorados Robson C."
        };

        this.props.originFormated =
            origins[this.props.origin] || this.props.origin;
    }
    statusTrialView() {
        const status = {
            "TRIAL E FREE": "Vigente",
            ATIVO: "Vigente",
            BLOQUEADO: "Expirado"
        };

        this.props.status.statusTrialView =
            status[_.get(this.props, "status.internal")] || "";
    }

    createdAtDateString() {
        this.props.createdAtString = this.props.createdAt
            ? new Date(this.props.createdAt)
            : "-";
    }

    expiredAtAtDateString() {
        if (_.get(this.props, "status.role") === "Contabilidade") {
            this.props.expiredAtString = "não expira";
        } else {
            this.props.expiredAtString = this.props.expiredAt
                ? new Date(this.props.expiredAt)
                : "-";
        }
    }

    formatTicketMedium() {
        if (!_.get(this.props, "summary.companies")) return;
        this.props.summary.companies.ticketMediumFormated = (
            _.get(this.props, "summary.companies.totalFees") /
            _.get(this.props, "summary.companies.total")
        ).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
        });
    }
    formatTotalFees() {
        if (!_.get(this.props, "summary.companies")) return;
        this.props.summary.companies.totalFeesFormated = _.get(
            this.props,
            "summary.companies.totalFees"
        ).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
        });
    }
    elapsedCompanies() {
        if (!_.get(this.props, "summary.eventsLastRegister")) return;
        this.props.summary.eventsLastRegister.elapsedCompanies = _.get(
            this.props,
            "summary.eventsLastRegister.companies"
        )
            ? formatElapsed(this.props.summary.eventsLastRegister.companies)
            : "N/A";
    }
    elapsedAccess() {
        if (!_.get(this.props, "summary.eventsLastRegister")) return;
        this.props.summary.eventsLastRegister.elapsedAccess = _.get(
            this.props,
            "summary.eventsLastRegister.companies"
        )
            ? formatElapsed(
                  _.get(this.props, "summary.eventsLastRegister.access")
              )
            : "N/A";
    }
}
